<template>
  <div>
    <label class="ts-uppercase ts-font-semibold ts-bg-blue-600 ts-text-white ts-px-1 ts-pt-1 ts-rounded-sm">{{
      $t('user.userAccount') }}</label>
    <!-- <div class="ts-w-40 ts-h-40 ts-border ts-mx-auto ts-rounded-full ts-p-1 ts-relative">
      <div class="ts-overflow-hidden ts-h-full ts-w-full ts-rounded-full">
        <img
          src="@/assets/default_user.jpg"
          alt
          class="ts-w-full ts-h-full ts-object-contain ts-object-top"
        />
      </div>
      <span
        class="ts-bottom-0 ts-left-0 ts-ml-2/3 ts-absolute ts-cursor-pointer ts-border ts-p-2 ts-rounded-full ts-bg-transparent hover:ts-bg-gray-100"
      >
        <i class="fas fa-camera fa-2x"></i>
      </span>
    </div>-->
    <div class="ts-grid xl:ts-grid-cols-4 xl:ts-gap-2 ts-gap-2 ts-mt-3">
      <label class="required xl:ts-text-right ts-pr-2 ts-my-auto">{{
        $t('user.staff')
      }}</label>
      <div class="ts-col-span-3">
        <a-select v-model="model.employee_id" showSearch :options="employees" :filterOption="(input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
          " :disabled="loading" @change="setDisplayName" class="ts-w-full xl:ts-w-4/5"></a-select>
        <div class="validate" v-if="errors.has('employee_id')">
          {{ errors.first('employee_id') }}
        </div>
      </div>
      <label class="required xl:ts-text-right ts-pr-2 ts-my-auto">{{
        $t('user.userName')
      }}</label>
      <div class="ts-col-span-3">
        <input v-model="model.username" type="text"
          class="ts-border ts-border-gray-400 ts-w-full xl:ts-w-4/5 ts-rounded-md ts-px-3 ts-py-2 ts-outline-none"
          :readonly="model.user_id > 0" :class="{
            'is-invalid': errors.has('username'),
            'ts-bg-gray-200': model.user_id
          }" />
        <div class="invalid-feedback" v-if="errors.has('username')">
          {{ errors.first('username') }}
        </div>
      </div>
      <label class="required xl:ts-text-right ts-pr-2 ts-my-auto" v-if="!model.user_id">{{ $t('user.password')
      }}</label>
      <div class="ts-col-span-3" v-if="!model.user_id">
        <input v-model="model.password" type="password"
          class="ts-border ts-border-gray-400 ts-w-full xl:ts-w-4/5 ts-rounded-md ts-px-3 ts-py-2 ts-outline-none"
          :readonly="model.user_id > 0" :class="{ 'is-invalid': errors.has('password') }" />
        <div class="invalid-feedback" v-if="errors.has('password')">
          {{ errors.first('password') }}
        </div>
      </div>
      <label class="required xl:ts-text-right ts-pr-2 ts-my-auto" v-if="!model.user_id">{{ $t('user.confirm') }}</label>
      <div class="ts-col-span-3" v-if="!model.user_id">
        <input v-model="model.password_confirmation" type="password"
          class="ts-border ts-border-gray-400 ts-w-full xl:ts-w-4/5 ts-rounded-md ts-px-3 ts-py-2 ts-outline-none"
          :readonly="model.user_id > 0" :class="{ 'is-invalid': errors.has('password_confirmation') }" />
        <div class="invalid-feedback" v-if="errors.has('password_confirmation')">
          {{ errors.first('password_confirmation') }}
        </div>
      </div>

      <label class="xl:ts-text-right ts-pr-2 ts-my-auto">{{
        $t('user.mobileRole')
      }}</label>
      <div class="ts-col-span-3">
        <select v-model="model.mobile_role_id"
          class="ts-border ts-border-gray-400 ts-w-full xl:ts-w-4/5 ts-rounded-md ts-px-3 ts-py-2 ts-outline-none"
          :class="{ 'is-invalid': errors.has('mobile_role_id') }" @change="onMobileRoleChange">
          <option v-for="(m, index) in mobileRoles" :key="index" :value="m.mobile_role_id">
            {{ m.description }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('mobile_role_id')">
          {{ errors.first('mobile_role_id') }}
        </div>
      </div>

      <label class="xl:ts-text-right ts-pr-2 ts-my-auto">{{ $t('user.reportTo') }}</label>
      <div class="ts-col-span-3">
        <a-select v-model="model.parent_user_id" showSearch :options="reportTo" :filterOption="(input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
          " :disabled="loading" class="ts-w-full xl:ts-w-4/5"></a-select>
        <div class="validate" v-if="errors.has('parent_user_id')">
          {{ errors.first('parent_user_id') }}
        </div>
      </div>
      <label class="xl:ts-text-right ts-pr-2 ts-my-auto">{{ $t('user.counter') }}</label>
      <div class="ts-col-span-3">
        <a-select v-model="model.counter_id" showSearch :options="counterList" :filterOption="(input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
          " class="ts-w-full xl:ts-w-4/5"></a-select>
        <div class="validate" v-if="errors.has('counter_id')">
          {{ errors.first('counter_id') }}
        </div>
      </div>

      <label class="xl:ts-text-right ts-pr-2 ts-my-auto">{{ $t('user.telegramUser') }}</label>
      <div class="ts-col-span-3">
        <input v-model="model.telegram_user"
          class="ts-border ts-border-gray-400 ts-w-full xl:ts-w-4/5 ts-rounded-md ts-px-3 ts-py-2 ts-outline-none"
          placeholder="@example" :class="{ 'is-invalid': errors.has('telegram_user') }" />
        <div class="validate" v-if="errors.has('telegram_user')">
          {{ errors.first('telegram_user') }}
        </div>
      </div>

      <label class="ts-mt-0"></label>
      <div class="ts-col-span-3">
        <div class="ts-grid ts-grid-cols-2 ts-gap-2">
          <ts-checkbox v-model="model.disable">{{
            $t('user.disable')
          }}</ts-checkbox>
          <ts-checkbox v-model="model.stock_alert">{{
            $t('user.stockAlert')
          }}</ts-checkbox>
          <ts-checkbox v-model="model.is_admin_password">{{
            $t('user.adminPassword')
          }}</ts-checkbox>
          <ts-checkbox v-model="model.allow_only_scan_on_transfer">{{
            $t('user.allow_only_scan_on_transfer')
          }}</ts-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  name: 'profileComponent',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      employees: [],
      roles: [],
      mobileRoles: [],
      reportTo: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
    this.fetchData()
  },
  computed: {
    isEdit() {
      return _.isEmpty(this.$store.state.security.user.edit_data)
    },
    counterList() {
      return this.$store.state.security.user.counters.map(el => ({
        value: el.counter_id,
        label: el.counter_name
      }))
    }
  },
  methods: {
    ...mapActions('security/user', ['getMobileRole', 'getReportTo', 'getGetCounter']),
    async fetchData() {
      this.loading = true
      await this.$store.dispatch('security/user/employee').then(response => {
        this.employees = response.data.map(el => ({
          value: el.employee_id,
          label: el.employee_name_en
        }))
      })
      await this.getGetCounter()
      await this.getMobileRole()
        .then(response => {
          this.mobileRoles = response.data
          if (!this.isEdit) {
            this.onMobileRoleChange()
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setDisplayName(value, opt) {
      this.employees
        .filter(e => e.value == value)
        .forEach(element => {
          this.model.name = element.label
        })
    },
    onMobileRoleChange() {
      if (this.isEdit) {
        this.model.parent_user_id = ''
      }
      this.reportTo = []
      var parent = this.mobileRoles.find(
        m => m.mobile_role_id == this.model.mobile_role_id
      )
      if (parent) {
        this.getReportTo(parent.parent_id).then(response => {
          this.reportTo = response.data.map(el => ({
            value: el.user_id,
            label: el.name
          }))
        })
      }
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
